import { Paper, Skeleton, Stack } from "@mui/material";
import Grid from "@mui/material/Grid2";

// Covers only the funnel/KPI/overview-donuts phase (Story 8's "funnel and
// overview charts" that must resolve first) - once those queries resolve,
// Users.tsx swaps this out for the real content while the 7 step sections
// below keep progressively loading via their own per-step skeletons (see
// UsersStepSkel.tsx / UsersStepSections.tsx).
export default function UsersSkel() {
  return (
    <Stack spacing={2.5}>
      <Skeleton variant="rounded" height={72} />

      <Grid container spacing={1.25}>
        {Array.from({ length: 4 }).map((_, index) => (
          <Grid size={6} key={index}>
            <Paper variant="outlined" sx={{ p: 1.75 }}>
              <Skeleton variant="text" width="50%" />
              <Skeleton variant="text" width="70%" height={32} />
              <Skeleton variant="text" width="90%" />
            </Paper>
          </Grid>
        ))}
      </Grid>

      <Skeleton variant="rounded" height={260} />

      <Grid container spacing={2.5}>
        <Grid size={{ xs: 12, md: 6 }}>
          <Skeleton variant="rounded" height={230} />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Skeleton variant="rounded" height={230} />
        </Grid>
      </Grid>
    </Stack>
  );
}
